<template>
  <!-- 需求设计不定，相关配置信息直接在标签配置 -->
  <!-- 字体大小 isBlock && 'block-info' paddingBottom: isVertical ? getIndentType() * 20 + 'px' : 0,paddingRight: isVertical ? 0 : getIndentType() * 20 + 'px', //原32-->
  <span
    :class="isBlock ? 'block-info treeboxtt' : 'treeboxtt'"
    :style="{
      paddingLeft: isVertical ? 0 : getIndentType() * 20 + 'px', //原32
      paddingTop: isVertical ? getIndentType() * 20 + 'px' : 0,
      letterSpacing: isVertical ? '1px' : 0,
      '-webkit-box-decoration-break': 'clone',
      '-o-box-decoration-break': 'clone',
      'box-decoration-break': 'clone',
    }"
  >
    <span
      v-for="(item, index) in nodeList"
      :key="index"
      :class="{ isVertical: isVertical }"
      :id="
        item.id
          ? 'page' + item.id
          : item.catalogId
          ? 'catalogId' + item.catalogId
          : ''
      "
      :data-id="item.id || item.catalogId"
      :style="{
        'text-align': item.type == '落款' ? 'right' : '',
      }"
      @contextmenu.prevent="getSelectData($event, item, nodeList)"
      @mouseup.prevent
    >
      <!-- @mousedown="removeSelectData($event, item)" -->
      <!-- @mouseup="getSelectData($event, item, nodeList)" -->
      <div v-if="item.label == '标题'">
        <div
          class="big-title"
          :class="{
            'align-centers': item.type == '1',
            'font-bold': item.type != '3',
          }"
          :style="{
            fontSize: getFontSize(item.type)
              ? getFontSize(item.type) * (1 + fontSize / 100) + 'px'
              : '',
            lineHeight: isVertical
              ? 40 * (1 + fontSize / 100) + 'px'
              : 30 * (1 + fontSize / 100) + 'px',
            padding: !isVertical
              ? getMargin(item.type) + 'px 0'
              : '0 ' + getMargin(item.type) + 'px',
          }"
        >
          <xml-tree
            :selectNoteData="selectData"
            :book-name="bookName"
            :keyword="keyword"
            :searchAccuracyType="searchAccuracyType"
            :noteOrQa="noteOrQa"
            :underline="underline"
            :underlineitem="
              underlineitem ||
              (item.id == underline.xmlId ? underline.text : '')
            "
            :myBookMarkMap="myBookMarkMap"
            :markMapitem="
              concatArrays(myBookMarkMap['sq' + item.id], markMapitem)
            "
            @select="onSelect"
            :fontSize="fontSize"
            :fontInitSize="getFontSize(item.type) * (1 + fontSize / 100)"
            :isVertical="isVertical"
            :node-list="item.child"
            :node-label="item.label"
            :indent-type="item.type"
          ></xml-tree>
        </div>
      </div>
      <span
        v-else-if="item.label == 'text'"
        v-html="
          brightenKeyword(
            item.content,
            keyword,
            noteOrQa,
            searchAccuracyType,
            underlineitem,
            concatArrays(myBookMarkMap['sq' + item.id], markMapitem)
          ) + `<span style='font-size:0'> </span>` //添加空格，笔记高亮
        "
      ></span>
      <div
        v-else-if="item.label == '书名'"
        class="mb20 align-centers font-bold"
        :style="{
          fontSize: getFontSize(item.label) * (1 + fontSize / 100) + 'px',
          padding: isVertical ? '0 60px' : '60px 0',
        }"
      >
        <xml-tree
          :selectNoteData="selectData"
          :book-name="bookName"
          :keyword="keyword"
          :searchAccuracyType="searchAccuracyType"
          :noteOrQa="noteOrQa"
          :underline="underline"
          :underlineitem="
            underlineitem || (item.id == underline.xmlId ? underline.text : '')
          "
          :myBookMarkMap="myBookMarkMap"
          :markMapitem="
            concatArrays(myBookMarkMap['sq' + item.id], markMapitem)
          "
          @select="onSelect"
          :fontSize="fontSize"
          :fontInitSize="getFontSize(item.label) * (1 + fontSize / 100)"
          :isVertical="isVertical"
          :node-list="item.child"
          :node-label="item.label"
          :indent-type="item.type"
        ></xml-tree>
      </div>
      <div
        v-else-if="item.label == '目录项'"
        class="mb10"
        style="margin-left: 0px"
      >
        <xml-tree
          :selectNoteData="selectData"
          :book-name="bookName"
          :keyword="keyword"
          :searchAccuracyType="searchAccuracyType"
          :noteOrQa="noteOrQa"
          :underline="underline"
          :underlineitem="
            underlineitem || (item.id == underline.xmlId ? underline.text : '')
          "
          :myBookMarkMap="myBookMarkMap"
          :markMapitem="
            concatArrays(myBookMarkMap['sq' + item.id], markMapitem)
          "
          @select="onSelect"
          :fontSize="fontSize"
          :fontInitSize="fontSize"
          :isVertical="isVertical"
          :node-list="item.child"
          :node-label="item.label"
          :indent-type="item.type"
        ></xml-tree>
      </div>
      <p
        v-else-if="item.label == '目录标题'"
        :style="{
          fontSize: getFontSize(item.type)
            ? getFontSize(item.type) * (1 + fontSize / 100) + 'px'
            : '',
        }"
        class="page-list-title"
      >
        <span
          v-html="
            brightenKeyword(
              item.child[0].content,
              keyword,
              noteOrQa,
              searchAccuracyType,
              underlineitem,
              concatArrays(myBookMarkMap['sq' + item.id], markMapitem)
            )
          "
        ></span>
        <span class="line">
          ————————————————————————————————————————————————————————————————————————————————————————————————————</span
        >
        <span
          v-html="
            brightenKeyword(
              nodeList[index + 1].child[0].content,
              keyword,
              noteOrQa,
              searchAccuracyType,
              underlineitem,
              concatArrays(myBookMarkMap['sq' + item.id], markMapitem)
            )
          "
        ></span>
      </p>
      <span v-else-if="item.label == '目录页码'">
        <div class="mb10"></div>
      </span>
      <span
        v-else-if="item.label == '目录册名'"
        :style="{
          fontSize: getFontSize(item.type)
            ? getFontSize(item.type) * (1 + fontSize / 100) + 'px'
            : '',
        }"
      >
        <xml-tree
          :selectNoteData="selectData"
          :book-name="bookName"
          :keyword="keyword"
          :searchAccuracyType="searchAccuracyType"
          :noteOrQa="noteOrQa"
          :underline="underline"
          :underlineitem="
            underlineitem || (item.id == underline.xmlId ? underline.text : '')
          "
          :myBookMarkMap="myBookMarkMap"
          :markMapitem="
            concatArrays(myBookMarkMap['sq' + item.id], markMapitem)
          "
          @select="onSelect"
          :fontSize="fontSize"
          :fontInitSize="getFontSize(item.type) * (1 + fontSize / 100)"
          :isVertical="isVertical"
          :node-list="item.child"
          :node-label="item.label"
          :indent-type="item.type"
        ></xml-tree>
        <div class="mb10"></div>
      </span>
      <span
        v-else-if="item.label == 'ML' || item.label == 'ml'"
        :style="{
          fontSize: getFontSize(item.type)
            ? getFontSize(item.type) * (1 + fontSize / 100) + 'px'
            : '',
        }"
        class="align-centers text-muted"
      >
      </span>
      <span
        v-else-if="item.label == 'page'"
        class="align-centers text-muted"
        :style="{
          fontSize: getFontSize(item.type)
            ? getFontSize(item.type) * (1 + fontSize / 100) + 'px'
            : '',
        }"
      >
      </span>
      <span
        v-else-if="item.label == '注释'"
        class="font-normal"
        :style="{
          lineHeight:
            item.type == '落款'
              ? '0px'
              : isVertical
              ? 40 * (1 + fontSize / 100) + 'px'
              : 30 * (1 + fontSize / 100) + 'px',
          fontSize: '0',
        }"
      >
        <span
          v-if="item.type == '落款'"
          :style="{
            fontSize: getFontSize(item.type) * (1 + fontSize / 100) + 'px',
            lineHeight: 30 * (1 + fontSize / 100) + 'px',
          }"
          class="align-right font-kai mb10"
        >
          <xml-tree
            :selectNoteData="selectData"
            :book-name="bookName"
            :keyword="keyword"
            :searchAccuracyType="searchAccuracyType"
            :noteOrQa="noteOrQa"
            :underline="underline"
            :underlineitem="
              underlineitem ||
              (item.id == underline.xmlId ? underline.text : '')
            "
            :myBookMarkMap="myBookMarkMap"
            :markMapitem="
              concatArrays(myBookMarkMap['sq' + item.id], markMapitem)
            "
            @select="onSelect"
            :fontSize="fontSize"
            :fontInitSize="getFontSize(item.type) * (1 + fontSize / 100)"
            :isVertical="isVertical"
            :node-list="item.child"
            :node-label="item.label"
            :indent-type="item.type"
          ></xml-tree>
        </span>
        <span
          v-if="item.type == '脚注-注'"
          :style="{
            fontSize: getFontSize(item.type)
              ? getFontSize(item.type) * (1 + fontSize / 100) + 'px'
              : '',
            color: '#000',
          }"
          class="text-success"
          ><i
            data-sign="footNote"
            :id="'page' + item.child[0].id"
            class="el-icon-info"
            :style="{
              color: '#cc3333',
              cursor: 'pointer',
              margin: 0,
              fontSize: '16px',
              letterSpacing: '10px',
            }"
            @click="emitUserEvent(item.child[0])"
          ></i
        ></span>
        <span
          v-if="item.type == '批注-注'"
          :style="{
            fontSize: getFontSize(item.type)
              ? getFontSize(item.type) * (1 + fontSize / 100) + 'px'
              : '',
          }"
          class="text-info"
        >
          <el-tooltip effect="dark">
            <span slot="content">
              批注-注：
              <xml-tree
                :selectNoteData="selectData"
                :book-name="bookName"
                :keyword="keyword"
                :searchAccuracyType="searchAccuracyType"
                :noteOrQa="noteOrQa"
                :underline="underline"
                :underlineitem="
                  underlineitem ||
                  (item.id == underline.xmlId ? underline.text : '')
                "
                :myBookMarkMap="myBookMarkMap"
                :markMapitem="
                  concatArrays(myBookMarkMap['sq' + item.id], markMapitem)
                "
                @select="onSelect"
                :fontSize="fontSize"
                :fontInitSize="getFontSize(item.type) * (1 + fontSize / 100)"
                :isVertical="isVertical"
                :node-list="item.child"
                :node-label="item.label"
                :indent-type="item.type"
              ></xml-tree>
            </span>
            <i class="el-icon-question"></i>
          </el-tooltip>
        </span>
        <span
          v-if="
            item.type == '疏1' ||
            item.type == '疏2' ||
            item.type == '疏3' ||
            item.type == '疏4'
          "
          :style="{
            fontSize: getFontSize(item.type)
              ? getFontSize(item.type) * (1 + fontSize / 100) + 'px'
              : '',
            color: '#762504',
            lineHeight: isVertical
              ? 40 * (1 + fontSize / 100) + 'px'
              : 30 * (1 + fontSize / 100) + 'px',
          }"
          class="text-navy"
        >
          <xml-tree
            :selectNoteData="selectData"
            :book-name="bookName"
            :keyword="keyword"
            :searchAccuracyType="searchAccuracyType"
            :noteOrQa="noteOrQa"
            :underline="underline"
            :underlineitem="
              underlineitem ||
              (item.id == underline.xmlId ? underline.text : '')
            "
            :myBookMarkMap="myBookMarkMap"
            :markMapitem="
              concatArrays(myBookMarkMap['sq' + item.id], markMapitem)
            "
            @select="onSelect"
            :fontSize="fontSize"
            :fontInitSize="getFontSize(item.type) * (1 + fontSize / 100)"
            fontInitColor="#762504"
            :isVertical="isVertical"
            :node-list="item.child"
            :node-label="item.label"
            :indent-type="item.type"
          ></xml-tree>
        </span>

        <span
          v-if="
            item.type == '注1' ||
            item.type == '注2' ||
            item.type == '注3' ||
            item.type == '注4' ||
            item.type == '目录注'
          "
          :style="{
            fontSize: getFontSize(item.type)
              ? getFontSize(item.type) * (1 + fontSize / 100) + 'px'
              : '',
            color: '#cc3333',
            lineHeight: isVertical
              ? 40 * (1 + fontSize / 100) + 'px'
              : 30 * (1 + fontSize / 100) + 'px',
          }"
          class="text-danger"
        >
          <xml-tree
            :selectNoteData="selectData"
            :book-name="bookName"
            :keyword="keyword"
            :searchAccuracyType="searchAccuracyType"
            :noteOrQa="noteOrQa"
            :underline="underline"
            :underlineitem="
              underlineitem ||
              (item.id == underline.xmlId ? underline.text : '')
            "
            :myBookMarkMap="myBookMarkMap"
            :markMapitem="
              concatArrays(myBookMarkMap['sq' + item.id], markMapitem)
            "
            @select="onSelect"
            :fontSize="fontSize"
            :fontInitSize="getFontSize(item.type) * (1 + fontSize / 100)"
            fontInitColor="#cc3333"
            :isVertical="isVertical"
            :node-list="item.child"
            :node-label="item.label"
            :indent-type="item.type"
          ></xml-tree>
        </span>
        <span
          v-if="item.type == '原色注'"
          :style="{
            fontSize: getFontSize(item.type)
              ? getFontSize(item.type) * (1 + fontSize / 100) + 'px'
              : '',
            lineHeight: isVertical
              ? 40 * (1 + fontSize / 100) + 'px'
              : 30 * (1 + fontSize / 100) + 'px',
          }"
        >
          <xml-tree
            :selectNoteData="selectData"
            :book-name="bookName"
            :keyword="keyword"
            :searchAccuracyType="searchAccuracyType"
            :noteOrQa="noteOrQa"
            :underline="underline"
            :underlineitem="
              underlineitem ||
              (item.id == underline.xmlId ? underline.text : '')
            "
            :myBookMarkMap="myBookMarkMap"
            :markMapitem="
              concatArrays(myBookMarkMap['sq' + item.id], markMapitem)
            "
            @select="onSelect"
            :fontSize="fontSize"
            :fontInitSize="getFontSize(item.type) * (1 + fontSize / 100)"
            :isVertical="isVertical"
            :node-list="item.child"
            :node-label="item.label"
            :indent-type="item.type"
          ></xml-tree>
        </span>
        <span
          v-if="item.type == '脚注-图片脚注'"
          :style="{
            fontSize: getFontSize(item.type)
              ? getFontSize(item.type) * (1 + fontSize / 100) + 'px'
              : '',
          }"
          class="text-warning"
        >
          <xml-tree
            :selectNoteData="selectData"
            :book-name="bookName"
            :keyword="keyword"
            :searchAccuracyType="searchAccuracyType"
            :noteOrQa="noteOrQa"
            :underline="underline"
            :underlineitem="
              underlineitem ||
              (item.id == underline.xmlId ? underline.text : '')
            "
            :myBookMarkMap="myBookMarkMap"
            :markMapitem="
              concatArrays(myBookMarkMap['sq' + item.id], markMapitem)
            "
            @select="onSelect"
            :fontSize="fontSize"
            :fontInitSize="getFontSize(item.type) * (1 + fontSize / 100)"
            :isVertical="isVertical"
            :node-list="item.child"
            :node-label="item.label"
            :indent-type="item.type"
          ></xml-tree>
        </span>
      </span>
      <span v-else-if="item.label == '段落'">
        <div class="mt20"></div>
        <div
          :style="{
            display: 'inline-block',
            margin: '0 auto',
            marginBottom: !isVertical && item.type != '落款' ? '20px' : '0',
            marginLeft: isVertical && item.type != '落款' ? '20px' : '0',
            width: !isVertical ? '100%' : '',
            height: isVertical ? '100%' : '',
          }"
        >
          <xml-tree
            :selectNoteData="selectData"
            :book-name="bookName"
            :keyword="keyword"
            :searchAccuracyType="searchAccuracyType"
            :noteOrQa="noteOrQa"
            :underline="underline"
            :underlineitem="
              underlineitem ||
              (item.id == underline.xmlId ? underline.text : '')
            "
            :myBookMarkMap="myBookMarkMap"
            :markMapitem="
              concatArrays(myBookMarkMap['sq' + item.id], markMapitem)
            "
            @select="onSelect"
            :fontSize="fontSize"
            :fontInitSize="fontInitSize"
            :isVertical="isVertical"
            :node-list="item.child"
            :node-label="item.label"
            :indent-type="item.type"
          ></xml-tree>
        </div>
      </span>
      <div
        v-else-if="item.label == '节'"
        :class="!isVertical ? 'mt10' : 'mv10'"
      ></div>
      <span
        class="image-emphasis"
        v-else-if="item.label == '字图'"
        :style="{
          letterSpacing: '-' + Math.ceil(parseInt(fontInitSize) / 2) + 'px',
        }"
      >
        <img
          :style="{
            height: item.size
              ? parseInt(fontInitSize) + parseInt(item.size) + 'px'
              : fontInitSize + 'px',
            width: 'auto',
            padding: '0 2px',
            verticalAlign: isVertical ? 'baseline' : 'text-bottom',
          }"
          class="text-img-size"
          @load="setImgSize"
          :src="baseImgPath + bookName + '/' + item.content"
        />
        <i
          class="after"
          :style="{
            left: isVertical ? '0' : '50%',
            bottom: isVertical ? '50%' : '0',
          }"
          >.</i
        >
      </span>
      <span
        v-else-if="item.label == '正文'"
        class="font-normal"
        :style="{
          fontSize: 0,
          lineHeight: isVertical
            ? 40 * (1 + fontSize / 100) + 'px'
            : 30 * (1 + fontSize / 100) + 'px', //30 * (1 + fontSize / 100) + 'px',
        }"
      >
        <span
          v-if="
            item.type == '正文小字1' ||
            item.type == '正文小字2' ||
            item.type == '正文小字3' ||
            item.type == '正文小字4'
          "
          :style="{
            fontSize: getFontSize(item.type)
              ? getFontSize(item.type) * (1 + fontSize / 100) + 'px'
              : '',
            lineHeight: isVertical
              ? 40 * (1 + fontSize / 100) + 'px'
              : 30 * (1 + fontSize / 100) + 'px',
          }"
        >
          <xml-tree
            :selectNoteData="selectData"
            :book-name="bookName"
            :keyword="keyword"
            :searchAccuracyType="searchAccuracyType"
            :noteOrQa="noteOrQa"
            :underline="underline"
            :underlineitem="
              underlineitem ||
              (item.id == underline.xmlId ? underline.text : '')
            "
            :myBookMarkMap="myBookMarkMap"
            :markMapitem="
              concatArrays(myBookMarkMap['sq' + item.id], markMapitem)
            "
            @select="onSelect"
            :fontSize="fontSize"
            :fontInitSize="getFontSize(item.type) * (1 + fontSize / 100)"
            :isVertical="isVertical"
            :node-list="item.child"
            :node-label="item.label"
            :indent-type="item.type"
          ></xml-tree>
        </span>
        <span
          v-if="
            item.type == '正文1' ||
            item.type == '正文2' ||
            item.type == '正文3' ||
            item.type == '正文4' ||
            item.type == '正文5'
          "
          :style="{
            fontSize: getFontSize(item.type)
              ? getFontSize(item.type) * (1 + fontSize / 100) + 'px'
              : '',
          }"
        >
          <xml-tree
            :selectNoteData="selectData"
            :book-name="bookName"
            :keyword="keyword"
            :searchAccuracyType="searchAccuracyType"
            :noteOrQa="noteOrQa"
            :underline="underline"
            :underlineitem="
              underlineitem ||
              (item.id == underline.xmlId ? underline.text : '')
            "
            :myBookMarkMap="myBookMarkMap"
            :markMapitem="
              concatArrays(myBookMarkMap['sq' + item.id], markMapitem)
            "
            @select="onSelect"
            :fontSize="fontSize"
            :fontInitSize="getFontSize(item.type) * (1 + fontSize / 100)"
            :isVertical="isVertical"
            :node-list="item.child"
            :node-label="item.label"
            :indent-type="item.type"
          ></xml-tree>
        </span>
      </span>
      <span
        v-else-if="item.label == '边框'"
        :style="{
          outline: '1px solid ' + fontInitColor,
          padding: isVertical ? '0px 3px;' : '2px 0 1px',
        }"
      >
        <xml-tree
          :selectNoteData="selectData"
          :book-name="bookName"
          :keyword="keyword"
          :searchAccuracyType="searchAccuracyType"
          :noteOrQa="noteOrQa"
          :underline="underline"
          :underlineitem="
            underlineitem || (item.id == underline.xmlId ? underline.text : '')
          "
          :myBookMarkMap="myBookMarkMap"
          :markMapitem="
            concatArrays(myBookMarkMap['sq' + item.id], markMapitem)
          "
          @select="onSelect"
          :fontSize="fontSize"
          :fontInitSize="fontInitSize"
          :isVertical="isVertical"
          :node-list="item.child"
          :node-label="item.label"
          :indent-type="item.type"
        ></xml-tree>
      </span>
      <!-- contentBoxSize.width + 'px' -->
      <div
        v-else-if="item.label == '图'"
        :style="{
          display: 'block',
          width: !isVertical ? '100%' : '',
          height: isVertical && '100%',
          textAlign: 'center',
        }"
        class="center"
      >
        <!-- 
            -->
        <img
          slot="reference"
          :id="'img-page' + item.id"
          :style="{
            maxWidth: isVertical ? 'auto' : '100%',
            maxHeight: isVertical ? '100%' : 'auto',
            width: item.size
              ? item.size.substr(0, item.size.indexOf(','))
                ? item.size.substr(0, item.size.indexOf(',')) + 'px'
                : 'auto'
              : '',
            height: item.size
              ? item.size.substr(item.size.indexOf(',') + 1)
                ? item.size.substr(item.size.indexOf(',') + 1) + 'px'
                : 'auto'
              : '',
          }"
          :src="baseImgPath + bookName + '/' + item.content"
          @click="clickImg(item)"
          @load="$root.$emit('imgload', {})"
        />
        <el-dialog
          @click="selfchange"
          title="   图片详情"
          width="80vw"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :visible="imgDeital[item.page + item.id]"
          @close="clickImg(item, true)"
          :style="{
            paddingRight: '10vw',
            boxsizing: 'boderbox',
          }"
        >
          <el-row>
            <el-col
              :span="18"
              :style="{
                height: '70vh',
                width: isVertical ? '65vw' : '',
                'writing-mode': 'horizontal-tb',
              }"
            >
              <viewer
                :options="{
                  title: () => getImgTile(item),
                  zoomRatio: 0.3,
                  toolbar: false,
                  navbar: false,
                  movable: true,
                  inline: true,
                  transition: true,
                  //rotatable: false, //旋转
                  //scalable: false, //翻转
                  fullscreen: false,
                  //minWidth: '1008',
                  //minHeigth: '70vh',
                  className: 'center',
                  //zoomOnTouch: false,
                  slideOnTouch: false,
                  //zIndex: 20000,
                }"
              >
                <img
                  style="display: none"
                  :src="baseImgPath + bookName + '/' + item.content"
                  :id="'img-page' + item.id"
                  :key="item.id"
                />
              </viewer>
              <!-- <el-image
                fit="contain"
                :src="baseImgPath + bookName + '/' + item.content"
                :preview-src-list="[
                  baseImgPath + bookName + '/' + item.content,
                ]"
              >
              </el-image> -->
            </el-col>
            <el-col :span="6">
              <ul>
                <li
                  class="img-note"
                  v-for="child in item.child"
                  :key="child.id"
                  v-if="child.type == '脚注-图片脚注'"
                  v-html="
                    brightenKeyword(
                      child.child[0].content,
                      keyword,
                      noteOrQa,
                      searchAccuracyType,
                      underlineitem,
                      concatArrays(myBookMarkMap['sq' + item.id], markMapitem)
                    )
                  "
                ></li>
              </ul>
            </el-col>
          </el-row>
        </el-dialog>
        <xml-tree
          :selectNoteData="selectData"
          :book-name="bookName"
          :keyword="keyword"
          :searchAccuracyType="searchAccuracyType"
          :noteOrQa="noteOrQa"
          :underline="underline"
          :underlineitem="
            underlineitem || (item.id == underline.xmlId ? underline.text : '')
          "
          :myBookMarkMap="myBookMarkMap"
          :markMapitem="
            concatArrays(myBookMarkMap['sq' + item.id], markMapitem)
          "
          @select="onSelect"
          :fontSize="fontSize"
          :fontInitSize="fontInitSize"
          :isVertical="isVertical"
          :node-list="item.child"
          :node-label="item.label"
          :indent-type="item.type"
          :isBlock="true"
        ></xml-tree>
      </div>
      <span
        v-else-if="item.label == '点'"
        :class="{
          circles: item.type == '圈',
          dots: !item.type || item.type == '点',
        }"
      >
        <xml-tree
          :selectNoteData="selectData"
          :book-name="bookName"
          :keyword="keyword"
          :searchAccuracyType="searchAccuracyType"
          :noteOrQa="noteOrQa"
          :underline="underline"
          :underlineitem="
            underlineitem || (item.id == underline.xmlId ? underline.text : '')
          "
          :myBookMarkMap="myBookMarkMap"
          :markMapitem="
            concatArrays(myBookMarkMap['sq' + item.id], markMapitem)
          "
          @select="onSelect"
          :fontSize="fontSize"
          :fontInitSize="fontInitSize"
          :isVertical="isVertical"
          :node-list="item.child"
          :node-label="item.label"
          :indent-type="item.type"
        ></xml-tree>
      </span>
      <div
        v-else-if="item.label == '子图'"
        class="zitu"
        :id="'zitu' + item.id"
      ></div>
      <xml-tree
        :selectNoteData="selectData"
        :book-name="bookName"
        :keyword="keyword"
        :searchAccuracyType="searchAccuracyType"
        :noteOrQa="noteOrQa"
        :underline="underline"
        :underlineitem="
          underlineitem || (item.id == underline.xmlId ? underline.text : '')
        "
        :myBookMarkMap="myBookMarkMap"
        :markMapitem="concatArrays(myBookMarkMap['sq' + item.id], markMapitem)"
        @select="onSelect"
        :fontSize="fontSize"
        :fontInitSize="fontInitSize"
        :isVertical="isVertical"
        v-else
        :node-list="item.child"
        :node-label="item.label"
        :indent-type="item.type"
      ></xml-tree>
    </span>
  </span>
</template>

<script>
export default {
  name: "xmlTree",
  props: {
    nodeList: {
      type: Array,
    },
    passageXmlId: 0, //高亮范围 xmlid
    keyword: "", //搜索关键字
    noteOrQa: "",//笔记反馈高亮
    indentType: null,
    isVertical: false,
    fontSize: 0,
    fontInitSize: {
      type: Number,
      default: 26,
    },
    fontInitColor: {
      type: String,
      default: '#636363',
    },
    isBlock: false,
    selectNoteData: {
      type: Object,
      default: () => {
        return {}
      },
    },
    bookName: {
      type: String,
      default: "",
    },
    nodeLabel: {
      type: String,
      default: "1",
    },
    type: {
      type: String,
      default: "1",
    },
    searchAccuracyType: true,//繁简通检
    myBookMarkMap: [],//书签
    markMapitem: {
      type: Array,
      default: () => []
    },//书签
    underline: {
      type: Object,
      default: () => {
        return {}
      },
    },//引用加下划线
    underlineitem: ""
    // xmlId:0
  },
  data () {
    return {
      baseUrl: window.__baseUrl__,
      keywordcount: 0,
      indentData: "32px",

      selectData: {},
      clickDownData: {},
      contentBoxSize: {},
      options: { title: (e) => console.log(e) },
      imgDeital: {},
    }
  },
  mounted () {
    // console.log(this.myBookMarkMap, '555')
    // let vie = document.getElementsByClassName("viewer-button")
    // console.log(vie, 'vie[0]')
    // vie[0] && vie[0].addEventListener("click", function () {
    //   console.log('dianji')
    // })

    // let viwe = document.querySelector(".viewer-button")
    // if (viwe) {
    //   viwe.onclick = function (e) {
    //     console.log(e)
    //   }
    // }


  },
  watch: {
    selectNoteData: {
      handler (val) {
        this.selectData = val
      },
      immediate: true,
      deep: true,
    },
  },
  created () {
    this.$root.$on("contentBoxSize", (size) => {
      this.contentBoxSize = size
    })
  },
  computed: {
    //  markMapKeys () {
    //   return Object.keys(this.myBookMarkMap)
    // }
    // concatBrightMart(){
    //   [...this.myBookMarkMap['sq' + this.xmlId], ...this.markMapitem]
    // }
  },
  methods: {
    selfchange (e) {
      console.log(e, 'eee')
    },
    quanping () {
      console.log("quanping")
    },
    // brightenKeyword(val,keyword){
    //   console.log(keyword);
    //   if(keyword.length>0){
    //     for(let i=0; i < keyword.length; i++){
    //       if(val.indexOf(keyword[i]) !== -1){
    //       // this.keywordcount = this.keywordcount+1;
    //       val=val.replace(
    //         new RegExp(keyword[i],'g'),
    //         '<font style="background:#ffff00;color: #3366cc;">'+keyword[i]+"</font>"
    //       )

    //     }
    //     }

    //     return val;
    //   }else{
    //     return val;
    //   }
    // },
    concatArrays (arr1 = [], arr2 = []) {
      return [...arr1, ...arr2]
    },
    clickImg (item, isClose) {
      this.imgDeital[item.page + item.id] = !isClose
      this.$forceUpdate()

    },
    showImg (item) {
      // console.log(item, 12);
    },
    getImgTile (item) {
      // console.log(item, 11)
      return ""
    },
    setImgSize (e) {
      // console.log(e.target.style.fontSize);
    },
    getIndentType () {
      if (this.nodeLabel !== "段落") {
        return 0
      }

      const type = this.indentType
      switch (type) {
        case "1":
        case "2":
        case "3":
        case "5":
          return 0
        case "4":
          return 2
        case "6":
          return 2
        case "7":
          return 2
        case "疏1":
        case "注1":
        case "正文1":
        case "正文小字1":
          return 0
        case "疏2":
        case "注2":
        case "正文2":
        case "正文小字2":
          return 1
        case "疏3":
        case "注3":
        case "正文3":
        case "正文小字3":
          return 2
        case "疏4":
        case "注4":
        case "正文4":
        case "正文小字4":
          return 3
        case "正文5":
          return 4
        default:
          return 0
      }
    },
    getFontSize (type) {
      switch (type) {
        case "书名":
          return 48 //26

        case "1":
          return 26

        case "2":
          return 25

        case "3":
          return 24
        case "4":
          return 22

        case "5":
          return 22

        case "6":
          return 21

        case "7":
          return 20
        case "疏1":
          return 16

        case "注1":
          return 16

        case "正文1":
        case "正文2":
        case "正文3":
        case "正文4":
        case "正文5":
          return 20 //17

        case "正文小字1":
        case "正文小字2":
        case "正文小字3":
        case "正文小字4":
        case "落款": //新增
          return 16 //14
        case "疏2":
          return 16
        case "注2":
          return 16

        case "脚注-图片脚注":
          return 16
        case "ML":
        case "ml":
        case "page":
          return 12
        case "疏3":
        case "注3":
          return 16 //2
        case "疏4":
        case "注4":
          return 16 //3
        case "原色注":
          return 12
      }
    },
    getMargin (type) {
      switch (type) {
        case "1":
          return 48
        // return 52;

        case "2":
          return 14
        // return 42

        case "3":
          return 12
        // return 32

        case "5":
          return 8
        case "4":
          return 10
      }
    },
    getSelectData (e, data, nodeList) {

      e.stopPropagation()
      let text =
        document.selection == undefined
          ? document.getSelection().toString()
          : document.selection.createRange().text
      // console.log(e, data, text, document.selection, '222')

      if (text) {
        this.$emit("select", e, data, text)
        document.querySelector(".treeboxtt").addEventListener('click', this.foo)
      } else {
        this.removeSelectData()
        // this.clickDownData = {};
      }
    },
    foo () {
      this.removeSelectData()
      document.querySelector(".treeboxtt").removeEventListener('click', this.foo)
    },

    removeSelectData (e, data) {
      // console.log("remove")
      e && e.stopPropagation()

      document.selection
        ? document.selection.empty()
        : document.getSelection() && document.getSelection().removeAllRanges()

      this.clickDownData = data
      this.$emit("select", null, null, null)
      // if (window.hightText) {
      //   window.hightText.removeAttribute("id");
      // }
      // console.log('xmltree')
      // let hightarr = document.querySelectorAll(".hightText");
      // if (hightarr) {
      //   hightarr.forEach((item) => {
      //     item.removeAttribute("class");
      //   });
      // }
    },
    // 处理递归
    onSelect (e, data, text) {
      // if (text) text = text.substring(0, 100)
      this.$emit("select", e, data, text)
    },
    getHightLight (content) {
      // if (content === this.selectData.notePage) {
      //   content = content.replace(
      //     new RegExp(this.selectData.noteTarget, "g"),
      //     (findContent) => {
      //       return `<span style="background:#108ee9;padding:7px 0;">${findContent}</span>`;
      //     }
      //   );
      // }
      return content
    },

    // 广播
    emitUserEvent (item) {
      // const id = "list" + item.selfId;
      // if (window[id]) {
      this.$root.$emit("clickNote", item.id)

      // }
    },

  },
};
</script>

<style lang="less">
// /deep/.viewer-canvas > img {
//   width: 0px;
//   height: 0px;
// }
// /deep/.viewer-canvas > img {
//   width: 0px;
//   height: 0px;
// }
.mt10 {
  height: 20px;
}
.mv10 {
  width: 20px;
}
/* .mt20{
  height: 20px;
} */
/deep/.viewer-canvas {
  display: flex;
  pointer-events: none;
}
/deep/.el-dialog__wrapper {
  pointer-events: none;
}
li.img-note {
  list-style: none;
  margin-bottom: 12px;
}
.font-22 {
  font-size: 22px;
}
.font-20 {
  font-size: 20px;
}
.font-19 {
  font-size: 19px;
}
.font-18 {
  font-size: 18px;
}
.font-17 {
  font-size: 17px;
}
.font-16 {
  font-size: 16px;
}
.font-15 {
  font-size: 15px;
}
.font-14 {
  font-size: 14px;
}
.font-13 {
  font-size: 13px;
}
.font-12 {
  font-size: 12px;
}
.font-11 {
  font-size: 11px;
}
.font-10 {
  font-size: 10px;
}
.font-9 {
  font-size: 9px;
}
.font-8 {
  font-size: 8px;
}
.font-bold {
  font-weight: bold;
}
.font-normal {
  font-weight: normal;
}
.align-centers {
  text-align: center;
}
.align-right {
  text-align: right;
}
.align-justify {
  word-break: normal;
  text-align: justify;
}
.padding-right {
  padding-right: 10px;
}
.font-kai {
  font-family: Kartika;
}
.height-line {
  line-height: 40px;
}
.text-img-size {
  width: 16px;
  height: auto;
  /* vertical-align: baseline; */
}

.img-box {
  width: 780px;
  max-width: 100%;
  text-align: center;
  margin: 0 auto;
  padding-left: 0;
}
.isVertical .img-box {
  max-height: 500px;
  max-width: initial;
  width: auto;
}

.isVertical .img-box img {
  max-height: 500px;
  max-width: initial;
  width: auto;
}

.img-box img {
  max-width: 100%;
  display: block;
  margin: 0 auto;
}
span {
  font-family: SimSun;
}
.isVertical .big-title {
  text-align: left;
  margin-top: 0 !important;
}
.block-info {
  display: block;
  width: 100%;
}

.block-info > span {
  display: block;
  width: 100%;
}

.block-info > span.isVertical {
  display: block;
  width: auto;
  height: 100%;
}

.page-list-title {
  display: flex;
}

.sehightText {
  // background: #ffff00;
  background: #fda69b;
}
.page-list-title .line {
  flex: 1;
  flex-grow: 1;
  overflow: hidden;
  margin: 0 14px;
}
/deep/.viewer-fullscreen {
  display: none;
}
.el-dialog__header {
  padding-right: 40px !important;
}
.circles {
  text-emphasis: open circle;
  -webkit-text-emphasis: open circle;
  text-emphasis-position: under left;
  -webkit-text-emphasis-position: under left;
}
.dots {
  // text-emphasis: filled circle;
  text-emphasis: filled dot;
  -webkit-text-emphasis: filled dot;
  text-emphasis-position: under left;
  -webkit-text-emphasis-position: under left;
}
.after {
  display: none;
}
// .image-emphasis {
//   // white-space: nowrap;
// }
.dots .image-emphasis {
  display: inline-block;
  position: relative;

  img {
    position: sticky;
    z-index: 1;
  }
  .after {
    display: inline-block;
    position: absolute;
    // content: ".";
    // bottom: 0;
    // left: 30%;
  }
}
.circles .image-emphasis {
  display: inline-block;
  position: relative;
  img {
    position: sticky;
    z-index: 1;
  }
  /* 伪元素用于装饰图片 */
  .after {
    display: inline-block;
    position: absolute;
    // content: ".";
    // bottom: 0;
    // left: 30%;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/xmlTree.vue